import { KeyIndexImpl } from '../instructions';
/**
 * @public
 */
export var DateFieldValues = [
    'era',
    'year',
    'quarter',
    'month',
    'week',
    'weekday',
    'weekdayOfMonth',
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'day',
    'dayperiod',
    'hour',
    'minute',
    'second',
    'zone',
];
/**
 * @public
 */
export var DateFieldWidthValues = ['short', 'narrow', 'wide'];
/**
 * @public
 */
export var RelativeTimeFieldValues = [
    'year',
    'quarter',
    'month',
    'week',
    'day',
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'hour',
    'minute',
    'second',
];
/**
 * @public
 */
export var DateFieldIndex = new KeyIndexImpl(DateFieldValues);
/**
 * @public
 */
export var DateFieldWidthIndex = new KeyIndexImpl(DateFieldWidthValues);
/**
 * @public
 */
export var RelativeTimeFieldIndex = new KeyIndexImpl(RelativeTimeFieldValues);
//# sourceMappingURL=datefields.js.map